import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import lodash from 'lodash';
import DamHelper, { EnumDamWallType } from '../../../../@types/model/dam/dam';
import { Autocomplete } from '@material-ui/lab';
import { FormHelperText, TextField } from '@material-ui/core';
import { createSelector } from 'reselect';

export interface IDamWallTypeDropDownOption {
    label : string;
    value : EnumDamWallType | null;
}

export interface IDamWallTypeSelectorProps {
    value : EnumDamWallType | null;
    disabled ?: boolean;
    className ?: string;
    required ?: boolean;
    onChange : (value : EnumDamWallType | null) => void;
    label ?: string;
}

interface IDamWallTypeSelectorState { }

class DamWallTypeSelector extends React.Component<IDamWallTypeSelectorProps, IDamWallTypeSelectorState> {
    constructor(props : IDamWallTypeSelectorProps) {
        super(props);

        this.state = {};
    }   

    private readonly onChange = (event : React.ChangeEvent<unknown>, value : {
        label : string;
        value : number | null;
    } | null | undefined) => {
        this.props.onChange(value?.value ?? null);
    };

    private readonly getValue = (state : IDamWallTypeSelectorState, props : IDamWallTypeSelectorProps) => props.value;
    private readonly getRequired = (state : IDamWallTypeSelectorState, props : IDamWallTypeSelectorProps) => props.required;

    private readonly getWallTypes = () => DamHelper.DamWallType;

    private readonly getWallTypesForDropdown = createSelector([
        this.getRequired, this.getWallTypes,
    ], (required, wallTypes) => {
        const dropdownData = lodash.map(wallTypes, (element, index) => ({ label: element, value: lodash.parseInt(index) } as IDamWallTypeDropDownOption));

        if (!required) {
            dropdownData.unshift({
                label: 'NONE',
                value: null,
            });
        }
        
        return dropdownData;
    });

    private readonly getSelectedValue = createSelector([
        this.getValue, this.getRequired, this.getWallTypes,
    ], (value, required, wallTypes) => {
        if (value != null) {
            const wallType = wallTypes[value];

            if (wallType) {
                return { label: wallType, value: value } as IDamWallTypeDropDownOption;
            }
        }
        return null;
    });

    public readonly render = () => {

        const { required, className, disabled, label } = this.props;

        const dropdownData = this.getWallTypesForDropdown(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);

        return (
            <FormControl margin={'normal'} fullWidth className={className} disabled={disabled} error={required && !value}>
                <Autocomplete 
                    id={'wallType'}
                    options={dropdownData}
                    value={value}
                    getOptionSelected={(option, val) => option.value === val.value}
                    getOptionLabel={option => option.label}
                    onChange={this.onChange}
                    disableClearable={required}
                    openOnFocus
                    renderInput={params => <TextField error={required && !value} {...params} fullWidth label={ label ?? 'Wall Types' } />}  
                />
                {
                    required && !value &&
                    <FormHelperText error>Required</FormHelperText>
                }
            </FormControl>
        );
    };

}

export default DamWallTypeSelector;